import '../assets/see-product.css';

function SeeProduct(){
    return(
        <div className='container see-containte mb-5'>
            <div className='paragraphe'>
                <h1 className='titre text-center text-uppercase'>LES BEST SELLER</h1>
                <p className='text mt-1'>
                    Discrète, compacte et facile à emporter partout, la cigarette électronique 
                    ou aussi appelée e-cig pour e-liquide est un système électronique de vape. 
                    Elle permet d’utiliser les e-liquide à base de nicotine mais aussi des concentrés
                    de CBD ou HHC ultra-relaxants pouvant être aromatisés d’une saveur de votre choix.
                    Il existe également des e-cig jetables prêt à l’emploi (Pod HHC, Pod vape pen, Wpuff…).
                    Dans cette collection, découvrez notre large choix de variétés de cigarettes 
                    électronique au meilleur prix avec différents arômes / saveurs et taux de CBD ou HHC différents. 
                    Livraison gratuite et des promotions exceptionnelles toutes l'année.
                </p>
                <a className='link text-center' href="#">Voir les products <img src={window.location.origin +"/images/fleche.png"} alt="" /></a>
            </div>
        </div>
    )
}

export default SeeProduct;